import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { config } from "@config";
import { CustomModal } from "@modules/core/components/base-modals";
import { Validateable } from "@models";
import { AccountService } from "@modules/account/services/account.service";
import { NewAccountFacade } from "@modules/new_account/domain/+state/new_account.facade";
import { take } from "rxjs/operators";
import { BestFacade } from "@modules/new_account/features/my-best/domain/+state/best.facade";
import { BEST_SYMBOL } from "@helpers/constants";

// BEST 2.0 opt-in terms
@Component({
	selector: "best-2-terms-modal",
	templateUrl: "./best-2-terms-modal.component.html",
	providers: [BestFacade],
	standalone: false
})
export class Best2TermsModalComponent extends CustomModal implements OnInit {
	@Input() public callback: Function;
	@Output() public onClose = new EventEmitter<boolean>();

	public termsSlider: TermsSlider = new TermsSlider();

	public constructor(
		private accountService: AccountService,
		private readonly accountFacade: NewAccountFacade,
		private readonly bestFacade: BestFacade
	) {
		super();
	}

	public ngOnInit(): void {
		this.accountFacade.getAccount().pipe(take(1));
	}

	public answer(accepted: boolean): void {
		if (accepted) {
			if (!this.termsSlider.accepted) {
				this.termsSlider.wiggle("accepted");
				return;
			}
			this.accountService.account.acceptBest2Terms();
			this.accountService.update();
			this.accountService.accountUpdated.subscribe((res) => {
				if (!res.saving && this.accountService.account.isBest2TermsAccepted()) {
					this.accountFacade.acceptBest2Terms();
					// refresh BEST state after accepting terms
					this.bestFacade.fetchBest();
					this.close("accepted");
					if (this.callback) {
						this.callback();
					}
				}
			});
		} else {
			this.close();
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public close(data: any = null, role: string = ""): void {
		this.onClose.emit(true);
		super.close(data, role);
	}

	public getTermsLink(): string {
		// Link only exists as de or en version, en is default
		const language: string = TranslationService.getLanguageIsoCode() === "de" ? "de" : "en";
		return config.baseUrl + language + config.externalPaths[BEST_SYMBOL]["best_two_legal"];
	}
}

class TermsSlider extends Validateable {
	public accepted: boolean = false;
}
